<template>
  <main class="app">
    <!-- Global Navigation -->
    <GlobalNavigation
      :data="contentStructure"
      :top-links="topLinks"
      :tooltip-list="navModel"
      :active-item="activeRoute"
      @emit-nav="getNav($event)"
      @emit-active-nav="getRoute($event)"
    >
      <!-- App -->
      <router-view
        slot="app-slot"
        :class="[
          'app__router',
          {
            'app__router--hidden': $route.name !== 'landing',
          },
        ]"
      />

      <!-- Footer -->
      <Footer slot="footer-slot" :hide-navigation="$route.params.hideNavigationFooter" />
    </GlobalNavigation>
    <Modal
      v-if="activeModal"
      :title="activeModal"
      @close-modal="getCurrentModal(null)"
    >
      <div slot="modal-slot">
        <Glossary
          v-if="activeModal === 'Glossary'"
          :data="modalContent.glossary"
        />

        <References
          v-else-if="activeModal === 'References'"
          :data="modalContent.references"
        />

        <Help
          v-else-if="activeModal === 'Help'">
          <SvgHelpSolri slot="image"/>
        </Help>
      </div>
    </Modal>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

import contentStructure from './content-structure';
import models from './content-structure/models';

import GlobalNavigation from '../../jazz-components/src/components/UIComponents/GlobalNavigation.vue';
import Footer from '../../jazz-components/src/components/UIComponents/Footer.vue';
import Modal from '../../jazz-components/src/components/UIComponents/Modal.vue';
import Glossary from '../../jazz-components/src/components/UIComponents/Glossary.vue';
import Help from '../../jazz-components/src/components/UIComponents/Help.vue';
import References from '../../jazz-components/src/components/UIComponents/References.vue';

export default {
  name: 'App',

  components: {
    GlobalNavigation,
    Footer,
    Modal,
    Glossary,
    Help,
    References,
    SvgHelpSolri: () => import('@/assets/svgs/help-asset-solriamfetol.svg?inline'),
  },

  data() {
    return {
      // Navigation
      activeNav: null,
      navModel: models.tooltipList,
      topLinks: models.landing.buttonMenuList.firstSet,
      modalContent: models.modals,
      transitionName: 'fade',
      contentStructure,
    };
  },

  computed: {
    ...mapGetters(['activeRoute', 'activeModal']),
  },

  methods: {
    ...mapActions(['getActiveRoute', 'getCurrentModal']),

    getNav(e) {
      this.activeNav = e;
    },

    getRoute(e) {
      this.getActiveRoute(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.app {
  position: relative;
  min-width: rem(1024);

  &__router {
    padding-right: rem(45);
    height: calc(100vh - 80px);
    background: #f5f5f5;
    width: calc(100vw - 154px);

    &--hidden {
      padding: rem(12) rem(45) rem(12) rem(45);
    }

    @include iPadProStyles {
      width: calc(100vw - 200px);
      height: calc(100vh - 105px);
    }
  }
}

</style>
